module.exports = __webpack_public_path__ + "static/media/download.d193fbb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/download.svg
// module id = 719
// module chunks = 0